import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import metricsReducer from "./slices/metricsSlice";
import adminReducer from "./slices/adminSlice";
import adUnitReducer from "./slices/adUnitSlice";
import settingsReducer from "./slices/settingsSlice";
import blockingReducer from "./slices/blockingSlice";
import notificationReducer from "./slices/notificationSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    metrics: metricsReducer,
    admin: adminReducer,
    adUnits: adUnitReducer,
    settings: settingsReducer,
    blocking: blockingReducer,
    notifications: notificationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
